/* eslint-disable max-len */
import React from 'react'
import SvgIcon from './SvgIcon'

export default props => (
  <SvgIcon {...props}>
    <path d="M14,18.1h-4c-0.6,0-1.1-0.5-1.1-1.1s0.5-1.1,1.1-1.1h4c0.6,0,1.1,0.5,1.1,1.1S14.6,18.1,14,18.1z M18,13.1H6 c-0.6,0-1.1-0.5-1.1-1.1s0.5-1.1,1.1-1.1h12c0.6,0,1.1,0.5,1.1,1.1S18.6,13.1,18,13.1z M21,8.1H3C2.4,8.1,1.9,7.6,1.9,7 S2.4,5.9,3,5.9h18c0.6,0,1.1,0.5,1.1,1.1S21.6,8.1,21,8.1z" />
  </SvgIcon>
)
